import React from 'react'
import { IMAGE_EXTENSION_TO_MIME } from 'components/Image/constants'

/**
 * @param extension
 * @param srcSet
 * @param isLazyLoading
 * @returns {JSX.Element}
 * @constructor
 */
export function ImageSource ({
  extension,
  srcSet,
  isLazyLoading
}) {
  const sourceSrcSet = srcSet.join(',')

  const props = {
    type: IMAGE_EXTENSION_TO_MIME[extension]
  }

  if (isLazyLoading) {
    props['data-srcset'] = sourceSrcSet
  } else {
    props.srcSet = sourceSrcSet
  }

  return <source {...props} />
}
